<template>
  <div v-if="solic">
    <v-card
      :class="[
        {
          'red lighten-1':
            solic.Beneficiarios.fecha_baja != null &&
            solic.Beneficiarios.fecha_baja != ''
        },
        {
          'green lighten-3':
            solic.Beneficiarios.fecha_baja == null ||
            solic.Beneficiarios.fecha_baja == ''
        }
      ]"
    >
      <v-card-text>
        <v-row no-gutters>
          <span>
            <h3>
              {{ solic.Beneficiarios.apellido_y_nombre.toUpperCase() }} -
              {{ afiparent }} ({{ edad }}) -
            </h3>
          </span>
          <span>
            <cboConvenio
              readonly
              v-model="solic.Beneficiarios.id_convenio_prestacional"
              texto
            ></cboConvenio>
          </span>
          <span class="mx-2"> - </span>
          <span
            ><cboPlan
              readonly
              texto
              :id_convenio="solic.Beneficiarios.id_convenio_prestacional"
              v-model="solic.Beneficiarios.id_plan"
            ></cboPlan>
          </span>
          <span class="mx-2"> - </span>
          <span>
            <cboLocalidades texto readonly v-model="localidad"></cboLocalidades>
          </span>
          <span class="mx-2"> - </span>
          <span>
            <provSeleccionada
              :value="solic.Beneficiarios.id_provincia"
              readonly
              texto
            ></provSeleccionada>
          </span>
        </v-row>
        <v-row
          no-gutters
          v-if="solic.Beneficiarios.id_tipo_afiliacion == 1 || discapacitado"
        >
          <span>
            <h2>Coseguro Exceptuado por :</h2>
          </span>
          <span class="mx-2 red--text" v-if="discapacitado">
            <h2>DISCAPACIDAD</h2>
          </span>
          <span
            class="mx-2 red--text"
            v-if="discapacitado && solic.Beneficiarios.id_tipo_afiliacion == 1"
          >
            <h2>-</h2>
          </span>
          <span
            class="mx-2 red--text"
            v-if="solic.Beneficiarios.id_tipo_afiliacion == 1"
          >
            <h2>
              <cboTipo_Afiliacion
                soloTexto
                v-model="solic.Beneficiarios.id_tipo_afiliacion"
              ></cboTipo_Afiliacion>
            </h2>
          </span>
        </v-row>
      </v-card-text>
    </v-card>
    <v-tabs v-model="tab" dark background-color="primary">
      <v-tab>
        <v-icon left>mdi-medical-bag</v-icon>
        Autorizacion
      </v-tab>
      <v-tab>
        <v-icon left>mdi-account</v-icon>
        Datos
      </v-tab>
      <v-tab>
        <v-icon left>mdi-view-list-outline</v-icon>
        Historial
      </v-tab>
      <v-tab-item>
        <v-card v-if="Loading" color="yellow lighten-2">
          <v-card-text>
            <h3>Cargando</h3>
            <h3>Por Favor Espere...</h3>
          </v-card-text>
          <v-overlay>
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-card>
        <Practica
          :auditoria="auditoria"
          v-if="solic"
          :soloderiva="soloderiva"
          :readonly="readonly"
          :solic="solic"
          @guardado="$emit('guardado')"
        ></Practica>
      </v-tab-item>
      <v-tab-item>
        <datos :beneficiario="solic.Beneficiarios"></datos>
      </v-tab-item>
      <v-tab-item>
        <lista :id_afiliado="solic.id_afiliado"></lista>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import cboConvenio from '@/components/ConveniosPrestacionales/Combo'
import cboPlan from '@/components/Planes/Combo'
import cboLocalidades from '@/components/Localidades/Combo'
import provSeleccionada from '@/components/Provincias/Combo'
import datos from '@/components/Beneficiarios/MostrarDatos'

import lista from '@/components/Practica/ListaPorBeneficiario'
import Practica from '@/components/Practica/Practica'
import cboTipo_Afiliacion from '@/components/Tipo_afiliacion/Combo'
import { mapActions, mapMutations } from 'vuex'
import LUM from '@/lib/LUM'
import API from '@/lib/API'
export default {
  props: {
    IdImagenes: Number,
    // solic: Object,
    idsolic: Number,
    auditoria: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    soloderiva: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tab: null,
      solic: undefined,
      Loading: false,
      motivoEstado: '',
      diagnostico: undefined,
      practica: '',
      efector: undefined,
      prescriptor: undefined,
      efectorprofesional: undefined,
      discapacitado: false,
      estados: [
        { id_estado: 1, descripcion_estado: 'Pendiente' },
        { id_estado: 2, descripcion_estado: 'Autorizado' },
        { id_estado: 3, descripcion_estado: 'En Gestion' },
        { id_estado: 4, descripcion_estado: 'Rechazado' }
      ]
    }
  },
  // asyncComputed: {
  //   solic: {
  //     get() {
  //       let ret = undefined
  //       API.Autorizaciones.traerUna(this.idsolic).then(
  //         (response) => (ret = response)
  //       )
  //       return ret
  //     }
  //   }
  // },
  computed: {
    afiparent() {
      if (this.solic) {
        return (
          this.solic.Beneficiarios.nro_afi +
          '/' +
          this.solic.Beneficiarios.parent
        )
      }
    },
    localidad: {
      get: function () {
        if (this.solic) {
          return {
            id_localidad: this.solic.Beneficiarios.id_localidad,
            codigo_postal: this.solic.Beneficiarios.codigo_postal,
            id_provincia: this.solic.Beneficiarios.id_provincia
          }
        }
      },
      set: function (newValue) {
        this.solic.Beneficiarios.id_localidad = newValue.id_localidad
        this.solic.Beneficiarios.id_provincia = newValue.id_provincia
        // 4151
      }
    },
    edad() {
      let ret = ''
      if (this.solic) {
        if (this.solic.Beneficiarios.fecha_nacimiento) {
          let anios = LUM.edad(
            new Date(
              this.solic.Beneficiarios.fecha_nacimiento.replace(/-/g, ',')
            )
          )
          if (anios || anios == 0) {
            ret = anios + (anios == 1 ? ' año' : ' años')
          }
        }
      }
      return ret
    },
    estado() {
      let ret = 'Sin Evaluar'
      if (this.solic) {
        switch (this.solic.estado) {
          case 1:
            ret = 'Pendiente'
            break
          case 2:
            ret = 'Autorizado'
            break
          case 3:
            ret = 'En Gestion'
            break
          case 4:
            ret = 'Rechazado'
            break
          case 5:
            ret = 'Cerrado'
            break
          default:
            break
        }
      }
      return ret
    }
  },
  methods: {
    ...mapMutations('comun', ['mostrar']),
    evaluarCantidad() {
      if (!this.solic.cantidad) {
        this.solic.cantidad = 1
      }
    },
    async evaluarDiscapacitado() {
      if (this.solic) {
        let ret = false
        let certs = await API.Certificados_Afiliados.traerPorAfiliado(
          this.solic.Beneficiarios.id_afiliado
        )
        if (certs) {
          ret =
            certs.findIndex(
              (x) =>
                x.tipo_certificado == 2 &&
                (!x.fecha_vencimiento ||
                  new Date(x.fecha_vencimiento.replace(/-/g, ',')) > new Date())
            ) > -1
        }
        this.discapacitado = ret
      }
    }
  },
  components: {
    datos,
    lista,
    Practica,
    cboConvenio,
    cboPlan,
    cboLocalidades,
    cboTipo_Afiliacion,
    provSeleccionada
  },
  async mounted() {
    this.solic = await API.Autorizaciones.traerUna(this.idsolic)
    this.evaluarDiscapacitado()
  },
  watch: {
    solic() {
      this.evaluarDiscapacitado()
    },
  }
}
</script>

<style></style>
